<template>
  <div class="input-dirs" v-loading="loading">
    <h4>Привязка полей к работам</h4>
    <div style="margin-bottom: 80px; width: 100%">
    <div v-for="input in inputs" class="list-inputs">
      <div class="name-line">
      <span>{{input.name}}</span>
      <el-checkbox size="medium" v-model="input.checkedJobs"></el-checkbox>
      </div>
      <div class="required-line">
        <span>Показывать в отчетах</span>
        <el-checkbox size="medium" v-model="input.showReportsCheck"></el-checkbox>
      </div>
    </div>
    </div>

    <div class="input-dirs__buttons">
      <el-button @click="$router.go(-1)">Отмена</el-button>
      <el-button type="primary" @click="update()">Сохранить</el-button>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase';
import _ from 'lodash';
import draggable from 'vuedraggable';
import {getAllInputs} from "../../../firestore/inputs";
import dayjs from "dayjs";

export default {
  name: 'ListDirs',
  components: {draggable},

  data() {
    return {
      loader: false,
      search: '',
      inputs: [],
      loading: false,
    };
  },

  async mounted() {
    this.fetchJobs();
  },

  methods: {
    save: _.debounce(function (el, binding) {
      const inputs = this.inputs.map((input, index) => {
        return {
          ...input,
          _data: {
            ...input._data,
            index: index,
          },
        };
      });

      this.update(inputs);
    }, 1000),

    async fetchJobs() {
      this.loader = true;
      const result = []
      firebase.firestore()
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('inputs')
        .get()
        .then(async (data) => {
          data.forEach((subDoc) => {
            let _data = subDoc.data();
            delete _data.options;
            result.push({..._data, checkedJobs: [...(_data.objects || [])].includes(this.$route.params.id), showReportsCheck: [...(_data.showReports || [])].includes(this.$route.params.id), id: subDoc.id});
          });

          console.log(result, 'result')

          this.inputs = [..._.orderBy(result, 'index', ['asc'])].filter(({type}) => type && (type.value === 'text' || type.value === 'number'))

        }).finally(() => {
        this.loader = false;
      })
    },
    async update() {
      this.loading = true


      let batch = firebase.firestore().batch();

      this.inputs.forEach((doc) => {
        let data = {
          ...doc,
        }

        delete data.id

        if(!data.objects) {
          data.objects = []
        }

        if(!data.showReports) {
          data.showReports = []
        }

        let i = data.objects.indexOf(this.$route.params.id);
        if(i >= 0) {
          data.objects.splice(i,1);
        }


        let n = data.showReports.indexOf(this.$route.params.id);
        if(n >= 0) {
          data.showReports.splice(i,1);
        }

        if(data.checkedJobs) {
          data.objects.push(this.$route.params.id)
        }

        if(data.showReportsCheck) {
          data.showReports.push(this.$route.params.id)
        }

        const docRef = firebase.firestore()
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('inputs')
          .doc(doc.id);

        batch.update(docRef, data);
      });
      await batch.commit();

      this.$notify.success({
        offset: 60,
        title: 'Успешно',
        message: 'Сохранено',
      });

      this.$router.go(-1);
      this.loading = false

    },
    deleteObject(id) {
      this.$confirm('Вы действительно хотите удалить?', 'Подтверждение', {
        confirmButtonText: 'Да',
        cancelButtonText: 'Нет',
        type: 'warning',
      }).then(() => {
        firebase.firestore()
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('inputs')
          .doc(id).delete()
          .then((data) => {
            this.$emit('update');
            this.fetchJobs();
            this.$notify({
              offset: 60,
              title: 'Успешно!',
              message: 'удалено',
              type: 'success',
            });
          });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.input-dirs__buttons {
  z-index: 999;
}
.input-dirs {
  max-width: 420px;
  margin: 0 auto;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  &__buttons {
    display: flex;
    justify-content: space-between;
    align-items: center;
    max-width: 420px;

    width: 100%;
    position: fixed;
    bottom: 20px;
  }

  .list-inputs {
    padding: 12px 16px;
    box-sizing: border-box;
    border-bottom: 1px solid rgba(0,0,0,.18);
    display: flex;
    flex: 1;
    flex-direction: column;
    width: 100%;
    align-items: flex-start;
    justify-content: space-between;
  }
}

.required-line {
  display: flex;
  span {
    margin-right: 16px;
    font-size: 13px;
  }
}

.name-line {
  display: flex;
  justify-content: space-between;
  flex: 1;
  width: 100%;
  margin-bottom: 12px;
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/Inputs/DirsJobs.vue